/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBitcoin: {
  name: 'bitcoin';
  data: string;
} = {
  name: 'bitcoin',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 3a1 1 0 0 0-2 0v1H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h1v1a1 1 0 1 0 2 0v-1h2v1a1 1 0 1 0 2 0v-1.1a5.002 5.002 0 0 0 1.8-9.043 4.002 4.002 0 0 0-1.8-6.73V2.999a1 1 0 1 0-2 0v1h-2V3Zm3 7a2 2 0 1 0 0-4H8v4h5Zm-.5 2H8v6h4.5c2.047 0 3.5-1.45 3.5-3s-1.453-3-3.5-3Z" fill="currentColor"/></svg>`,
};
